import activityApi from '../../api/activity'
import * as types from '../mutation-types'
import Dialog from '../../plugins/dialog.js'

const state = {
  activities: { activities: [], shareData: {} },
  activity: {},
  activityPageSize: 10,
  activityPageIndex: 1,
  activityMaxPageSize: 1,
  rewards: [],
  products: [],
  product: {},
  productPageSize: 10,
  productPageIndex: 1,
  productMaxPageSize: 1
}

const getters = {
  activities: state => state.activities,
  activity: state => state.activity,
  isActivityPageEnd: state =>
    state.activityPageIndex >= state.activityMaxPageSize,
  activityCount: (state, getters) => getters.activities.length,
  rewards: state => state.rewards,
  products: state => state.products,
  product: state => state.product,
  isProductPageEnd: state => state.productPageIndex >= state.productMaxPageSize
}

const mutations = {
  [types.RECEIVE_ACTIVITY_LIST](state, { activities }) {
    state.activities = activities
  },
  [types.RECEIVE_ACTIVITY_DETAIL](state, { activity }) {
    state.activity = activity
  },
  // 设置活动最大页数
  [types.SET_ACTIVITY_MAXPAGESIZE](state, { activityMaxPageSize }) {
    state.activityMaxPageSize = activityMaxPageSize
  },
  // 设置当前活动页数
  [types.SET_ACTIVITY_PAGEINDEX](state, { activityPageIndex }) {
    state.activityPageIndex = activityPageIndex
  },
  // 追加活动列表
  [types.APPEND_ACTIVITY_LIST](state, { list }) {
    if (list && list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        state.activities.activities.push(list[i])
      }
    }
  },
  [types.RECEIVE_REWARD_LIST](state, { rewards }) {
    state.rewards = rewards
  },
  [types.RECEIVE_PRODUCT_LIST](state, { products }) {
    state.products = products
  },
  [types.RECEIVE_PRODUCT_DETAIL](state, { product }) {
    state.product = product
  },
  // 设置商品最大页数
  [types.SET_PRODUCT_MAXPAGESIZE](state, { productMaxPageSize }) {
    state.productMaxPageSize = productMaxPageSize
  },
  // 设置当前商品页数
  [types.SET_PRODUCT_PAGEINDEX](state, { productPageIndex }) {
    state.productPageIndex = productPageIndex
  },
  // 追加商品列表
  [types.APPEND_PRODUCT_LIST](state, { list }) {
    if (list && list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        state.products.push(list[i])
      }
    }
  }
}

const actions = {
  /**
   * 获取活动列表
   */
  getActivityList(
    { state, getters, commit, rootState },
    { cityId, pvAreaId, pageSize }
  ) {
    commit(types.SET_ACTIVITY_PAGEINDEX, { activityPageIndex: 1 })
    return activityApi
      .getActivityList({
        cityId,
        pvAreaId,
        pageSize: pageSize || state.activityPageSize,
        pageNum: state.activityPageIndex
      })
      .then(function (response) {
        if (!response) {
          return
        }
        if (response.data.returnCode === 0) {
          commit(types.RECEIVE_ACTIVITY_LIST, {
            activities: response.data.result
          })
        } else {
          Dialog.toast({ title: response.data.message })
        }
      })
  },
  /**
   * 获取活动详情
   */
  getActivityDetail({ state, getters, commit }, param) {
    return activityApi
      .getActivityDetail({
        platformActivityId: param.platformActivityId,
        pvAreaId: param.pvAreaId,
        cityId: param.cityId,
        popupseriesid: param.popupseriesid,
        popuptype: param.popuptype,
        popuppvid: param.popuppvid,
      })
      .then(function (response) {
        if (response && response.data.returnCode === 0) {
          if (response.data.result === null) {
            commit(types.RECEIVE_ACTIVITY_DETAIL, { activity: { id: 0 } })
          } else {
            commit(types.RECEIVE_ACTIVITY_DETAIL, {
              activity: response.data.result
            })
          }
        } else {
          Dialog.toast({ title: response.data.message })
        }
      })
  },
  /**
   * 获取最新奖励列表
   */
  getRewardList({ state, getters, commit }, { pvAreaId }) {
    return activityApi.getRewardList({ pvAreaId }).then(function (response) {
      if (!response) {
        return
      }
      if (response.data.returnCode === 0) {
        commit(types.RECEIVE_REWARD_LIST, { rewards: response.data.result })
      } else {
        Dialog.toast({ title: response.data.message })
      }
    })
  },
  /**
   * 获取商品列表
   */
  getProductList({ state, getters, commit }, { cityId, pvAreaId, pageSize }) {
    commit(types.SET_PRODUCT_PAGEINDEX, { productPageIndex: 1 })
    return activityApi
      .getProductList({
        cityId,
        pvAreaId,
        pageSize: pageSize || state.productPageSize,
        pageNum: state.productPageIndex
      })
      .then(function (response) {
        if (!response) {
          return
        }
        if (response.data.returnCode === 0) {
          commit(types.RECEIVE_PRODUCT_LIST, {
            products: response.data.result.goodList
          })
          commit(types.SET_PRODUCT_MAXPAGESIZE, {
            productMaxPageSize: response.data.result.totalCount
          })
        } else {
          Dialog.toast({ title: response.data.message })
        }
      })
  },
  /**
   * 获取商品详情
   */
  getProductDetail({ state, getters, commit }, param) {
    return activityApi
      .getProductDetail({
        platformActivityId: param.platformActivityId,
        pvAreaId: param.pvAreaId
      })
      .then(function (response) {
        if (response && response.data.returnCode === 0) {
          if (response.data.result === null) {
            commit(types.RECEIVE_PRODUCT_DETAIL, { product: { id: 0 } })
          } else {
            commit(types.RECEIVE_PRODUCT_DETAIL, {
              product: response.data.result
            })
          }
        } else {
          Dialog.toast({ title: response.data.message })
        }
      })
  },
  // 加载更多
  loadMoreProducts({ commit, getters }) {
    const pageNo = state.productPageIndex + 1
    commit(types.SET_PRODUCT_PAGEINDEX, { productPageIndex: pageNo })
    let promise = activityApi
      .getProductList({
        category: getters.category,
        sort: getters.sort,
        pageSize: state.productPageSize,
        pageNum: state.productPageIndex
      })
      .then(res => {
        if (!res) {
          return
        }
        var list = res.data.result.goodList
        commit(types.APPEND_PRODUCT_LIST, { list: list })
      })
    return promise
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/activity.js